import { openDecisionChain } from "@/features/documents/lib/decision-chain-store";
import { cardChoice } from "@/features/intelligence/lib/card-choice";
import type { HandlerOutcome } from "@/features/intelligence/lib/frontend-tool-run";
import type { PrepareDecisionChainArgs } from "@/features/intelligence/lib/frontend-tools";
import {
  choiceResult,
  searchedInstead,
  shownResult,
} from "@/features/intelligence/lib/tool-result";

export async function prepareDecisionChain(
  { seed, ignored, notAnId }: PrepareDecisionChainArgs,
  toolCallId: string,
): Promise<HandlerOutcome> {
  openDecisionChain(toolCallId, seed);
  const choice = await cardChoice(seed, false);
  if (choice.kind !== "chosen") {
    return choiceResult(
      choice,
      searchedInstead(
        `A decision-chain card is in the chat. Once the client and the advice are chosen, it ${READS}`,
        seed,
        notAnId,
      ),
      KEEP_OUT,
      ignored,
      "the client or the advice",
    );
  }
  const asks =
    seed.adviceDate === null
      ? "; it asks the advisor which advice when the client has several"
      : "; it asks the advisor which advice unless exactly one of the client's advices is from " +
        "that date, and says so when none is";
  return shownResult(
    searchedInstead(
      `A decision-chain card is shown in the chat. You cannot see what it shows: it ${READS}${asks}`,
      seed,
      notAnId,
    ),
    `points to the card and says nothing about what is in it; ${KEEP_OUT}, and do not ask for ` +
      "anything in text",
    ignored,
  );
}

const READS =
  "reads the advice, its sealed PDF, the portfolio suggestion with its transactions and the " +
  "order instruction itself, and none of them reach you. It writes nothing. It then offers " +
  "the advisor a compliance PDF with the originals attached";

const KEEP_OUT =
  "do not describe, summarise, list or guess the advice, its dates, its status or its " +
  "figures, and do not offer a PDF yourself";
